import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowLeft } from 'lucide-react';
import { PublicHeader } from './PublicHeader';
import { Footer } from './Footer';

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-bw-app">
      <PublicHeader />
      
      <div className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="relative bg-bw-sidebar rounded-lg shadow-lg p-12 mb-12 overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
            </div>
            
            <div className="relative text-center text-white">
              <div className="flex items-center justify-center mb-6">
                <Zap className="h-16 w-16 text-bw-accent animate-bounce" />
              </div>
              <h1 className="text-6xl font-bold mb-4">404</h1>
              <h2 className="text-3xl font-bold mb-6">Page Not Found</h2>
              <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
                Looks like this contract opportunity has expired or never existed. Let's get you back to active opportunities.
              </p>
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-servet-red hover:bg-servet-red/90"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Return to Homepage
              </Link>
            </div>
          </div>

          <div className="bg-bw-surface rounded-xl shadow-lg p-8 text-center">
            <h3 className="text-lg font-medium text-bw-ink mb-4">
              Looking for something specific?
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/dashboard"
                className="inline-flex items-center px-4 py-2 border border-servet-blue text-sm font-medium rounded-md text-bw-primary hover:bg-bw-primary-tint"
              >
                View Contract Opportunities
              </Link>
              <Link
                to="/support"
                className="inline-flex items-center px-4 py-2 border border-servet-blue text-sm font-medium rounded-md text-bw-primary hover:bg-bw-primary-tint"
              >
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}